import { render, staticRenderFns } from "./partnerForm.vue?vue&type=template&id=3f1dbfc8&scoped=true"
import script from "./partnerForm.vue?vue&type=script&lang=js"
export * from "./partnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1dbfc8",
  null
  
)

export default component.exports